import Asset from "../../requests/apa/Asset";
import Translator from '../../requests/apa/Translator'
import RequestManager from "../../requests/RequestManager";
import PBIFromRegisterTask from "../../requests/tasks/payway/PBIFromRegisterTask";
import OffersV4Task from '../../requests/tasks/cms/OffersV4Task';
import Utils from "../../utils/Utils";
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import {getTransactionalPrice, getTransactionalTax, getTransactionalBonus, getTransactionalBonusComplement} from '../utils/Utils';
import {TRANSACTION_COMPONENT_LANDING, TRANSACTION_COMPONENT_PLAN_SELECTOR} from '../utils/constants.ts';
import { getOffersV4Flag } from '../../utils/offersV4FlagResolver';
import PurchaseButtonInfoV2_2Task from "src/requests/tasks/payway/PurchaseButtonInfoV2_2Task";
import { enablePaymentMethodExperience } from "../../utils/Utils";

export const getPlans = (params) => {
    const pbiFromRegisterTask = enablePaymentMethodExperience() ? 
        new PurchaseButtonInfoV2_2Task(params) : 
        new PBIFromRegisterTask(params);
    return RequestManager.addRequest(pbiFromRegisterTask);
}

export const getPlansOffersV4 = (url = null) => {
    const offersV4Task = new OffersV4Task(url);
    return RequestManager.addRequest(offersV4Task);
}

export const getPlanSelectorPlansResponse = async (params = {}) => {
    const getLegacyPlansResponse = async () => {
        const response = await getPlans(params);

        return {
            mode: 'pbi',
            response,
        };
    };

    try {
        const countryKey = DeviceStorage.getItem('region');
        const flag = getOffersV4Flag(countryKey);
        const isOffersV4Enabled = flag && flag.enabled === true;

        if (isOffersV4Enabled) {
            try {
                const response = await getPlansOffersV4();

                if (response && Array.isArray(response.data) && response.data.length > 0) {
                    return {
                        mode: 'offersV4',
                        response,
                    };
                }

                if (response && Array.isArray(response.offers) && response.offers.length > 0) {
                    return {
                        mode: 'offersV4',
                        response,
                    };
                }

                return getLegacyPlansResponse();
            } catch (error) {
                const legacyResponse = await getLegacyPlansResponse();
                return {
                    ...legacyResponse,
                    fallbackReason: error,
                };
            }
        }
    } catch (error) {
    }

    return getLegacyPlansResponse();
}

export const parsePlans = (plans, handlePlanClick = () => {}, labels) => plans.map(plan => {
   return parsePlan(plan, handlePlanClick, labels);
});

export const parsePlan = (plan, handlePlanClick, labels) => {
    const region = DeviceStorage.getItem("region") || "default";
    let backgroundAssetImage = Asset.get(`${plan.banner || ''}`.toLowerCase());
    const fallbackImage = Asset.get(`${plan.banner || ''}`.toLowerCase());

    plan.request = Utils.getRequest(plan.linkworkflowstart);

    // * Si la región no es la predeterminada, intentamos obtener la imagen con la región
    if (region !== 'default') {
        backgroundAssetImage = Asset.get(`${plan.banner || ''}_${region}`.toLowerCase());

        //* Si no se encuentra la imagen, usamos la predeterminada
        if (backgroundAssetImage === `${plan.banner}_${region}`) {
            backgroundAssetImage = Asset.get(`${plan.banner || ''}`.toLowerCase());
        }
    }

    const providerLogo = Asset.get(`transactional_${plan.family}_logo`);
    /**
     * Usar únicamente en el selector de planes
     * @param alineacion debe tener uno de estos valores: Izquierda, Derecha o Centrado.
     * @param region parámetro opcional
     */
    const providerLogoPlanSelectorRegion = Asset.get(`SelectorDePlan_Tarjeta_ImagenLogo_${plan.family}_Centrado_${region}`);
    const providerLogoPlanSelectorNoRegion = Asset.get(`SelectorDePlan_Tarjeta_ImagenLogo_${plan.family}_Centrado`);
    const validateProviderLogo = providerLogoPlanSelectorRegion.includes('SelectorDePlan_Tarjeta_ImagenLogo_');
    const providerLogoPlanSelector = validateProviderLogo ? providerLogoPlanSelectorNoRegion : providerLogoPlanSelectorRegion;
    const buttonColorText = Translator.get(`${plan.style || ''}_text`);
    const buttonColorBG = Translator.get(`${plan.style || ''}`);
    const isButtonVisible = plan.hasOwnProperty('purchasable') ? plan.purchasable : true;
    const planSelectorPrice = getTransactionalPrice({
        component: TRANSACTION_COMPONENT_PLAN_SELECTOR,
        currency:plan.currency,
        price:plan.price,
    });
    const planSelectorTax = getTransactionalTax({
        component: TRANSACTION_COMPONENT_PLAN_SELECTOR,
        producttype: plan.producttype,
        periodicity: plan.periodicity
    });
    const planSelectorBonus = getTransactionalBonus({
        component: TRANSACTION_COMPONENT_PLAN_SELECTOR,
        bonus: plan.bonus,
        producttype: plan.producttype,
        family: plan.family
    })

    return {
        id: plan.offerid,
        buttonText: Translator.get(plan.buy),
        buttonTextColorHex: buttonColorText,
        buttonBGColorHex: buttonColorBG,
        provider: plan.producttype,
        family: plan.family,
        offerid: plan.offerid,
        backgroundImage: backgroundAssetImage,
        providerLogo: providerLogo,
        providerLogoPlanSelector: providerLogoPlanSelector,
        planSelectorPrice, //[Plan Selector] Precio Ej. $ 9999 / Mes
        planSelectorTax, //[Plan Selector] Impuesto/Periodicidad Ej. IVA incluido
        planSelectorBonus, //[Plan Selector] Bonificación Ej. Disfruta 30 días sin costo
        onPlanClick: handlePlanClick && typeof handlePlanClick === 'function' ? ()=>{handlePlanClick(plan)} : null,
        isButtonVisible,
        fallbackImage
    }
}

export const parseDetailPlan = (plans, labels) => plans.map(plan => {
    const { textNoBonus } = labels;
    const buttons = plans.filter((p)=>p.family === plan.family).map((plan)=>{

        const landingPrice = getTransactionalPrice({
            component: TRANSACTION_COMPONENT_LANDING,
            currency:plan.currency,
            price:plan.price,
            producttype: plan.producttype,
            periodicity: plan.periodicity
            });

        const landingTax = getTransactionalTax({
            component: TRANSACTION_COMPONENT_LANDING,
            producttype: plan.producttype,
            periodicity: plan.periodicity
        });

        const landingBonus = getTransactionalBonus({
            component: TRANSACTION_COMPONENT_LANDING,
            bonus: plan.bonus,
            producttype: plan.producttype,
            family: plan.family
        });

        const landingBonusComplement = getTransactionalBonusComplement({
            component: TRANSACTION_COMPONENT_LANDING,
            bonus: plan.bonus,
        });

        return {...plan,
            bonusButton: Translator.get(`${plan.bonus}_button`, textNoBonus),
            period: Translator.get(`${plan.bonus}_button`, textNoBonus),
            textTrial: Translator.get(`${plan.producttype}_subscriptionDescription_test_button`, ''),
            additionalInfo: Translator.get(`${plan.producttype}_subscriptionDescription_additionalInfo_label`, false),
            offerTitle: Translator.get(`${plan.producttype}_subscriptionDescription_offerTitle_label`, false),
            landingPrice,//[Landing Comercial] Precio Ej. $ 9999 / Mes,
            landingTax,//[Landing Comercial] Impuesto/Periodicidad Ej. IVA incluido,
            landingBonus,//[Landing Comercial] Bonificación Ej. Disfruta 7 días sin costo <Texto azul>
            landingBonusComplement//[Landing Comercial] Sufijo de bonificación Ej. , después
        }
    });

    return {
        id: plan.offerid,
        pbi: plan,
        buttons,
    }
});



// WEBPACK FOOTER //
// ./src/payments/PlanSelector/PlanSelectorUtils.js